export const GET_CULTURAL_TYPES = 'GET_CULTURAL_TYPES';
export const GET_FACILITIES = 'GET_FACILITIES';
export const GET_NUTS_POP = 'GET_NUTS_POP';
export const GET_NUTS_POP2 = 'GET_NUTS_POP2';
export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_LAU_FROM_NUTS = 'GET_LAU_FROM_NUTS';
export const NUTS = 'NUTS';
export const GET_LAU_CODE_FROM_NAME = 'GET_LAU_CODE_FROM_NAME';
export const GET_EVENTS = 'GET_EVENTS';
export const GET_CULTURAL_FACILITIES = 'GET_CULTURAL_FACILITIES';
export const GET_ITALIAN_ED_FACILITIES = 'GET_ITALIAN_ED_FACILITIES';
export const FEDERATE_QUERY_ON_SCHOOLS = 'FEDERATE_QUERY_ON_SCHOOLS';
export const GET_POP_FROM_MUNICIPALITY = 'GET_POP_FROM_MUNICIPALITY';


